import i18next from "i18next";

import { CONTEXT_MALE_VALUE, ITEM_GENDER_CONTEXT } from "@/constants/Languages";

const getItemContext = (itemName) => {
  return ITEM_GENDER_CONTEXT[itemName?.toUpperCase()] ?? CONTEXT_MALE_VALUE;
};

const getLoadMoreParams = (pagination) => {
  if (!pagination?.meta) return false;

  const { current_page, last_page, per_page, total } = pagination.meta;

  if (current_page === last_page) return false;

  if (!total) return {};

  const loadedCount = current_page * per_page;
  const remaningCount = total - loadedCount;
  const nextPageCount = remaningCount > per_page ? per_page : remaningCount;

  return {
    nextPageCount,
    remaningCount,
  };
};

export const getButtonText = (pagination, itemName) => {
  const translationKeyBase = "global:listLoadMoreButton";
  const params = getLoadMoreParams(pagination);

  if (!params) return false;

  const { nextPageCount, remaningCount } = params;

  if (!nextPageCount || !remaningCount) {
    return i18next.t(`${translationKeyBase}.generic`);
  }

  const item = itemName.toLowerCase();
  const context = getItemContext(itemName); // context = item gender
  const ctaValues = { context, item, count: nextPageCount };

  if (nextPageCount === remaningCount) {
    return i18next.t(`${translationKeyBase}.lastPage`, ctaValues);
  }

  const ctaText = i18next.t(`${translationKeyBase}.nextPage`, ctaValues);
  const remaningValues = { context, count: remaningCount };
  const remaningText = i18next.t(`${translationKeyBase}.total`, remaningValues);

  return `${ctaText} (${remaningText})`;
};
